import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setJobModal } from "../../../redux/userReducer";
import Reasonselect from "../../Common/DropDown/DropDown";
import "./JobModal.scss";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import graphqlRequest from "../../../requestMethod";
import eventHelpers from "../../../Helpers/Event";
import { pushEvent } from "../../../utils/clevertap";
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  IconButton,
  Paper,
  Alert,
  createTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
const theme = createTheme();

function JobOptionModel({ jobPostRemoveId, removeOpenJob, title }) {
  let dispatch = useDispatch();
  let [reasonToRemove, setReasonToRemove] = useState({
    reason: "",
    comment: "",
  });
  let [reasonToRemoveError, setReasonToRemoveError] = useState({});
  function handleJobPost(jobType) {
    dispatch(setJobModal());
  }
  function handleRemove() {
    removeOpenJob(jobPostRemoveId?.allData?.id, reasonToRemove);
    dispatch(setJobModal());
  }

  function validate() {
    let error = {};
    if (!reasonToRemove.reason) {
      error.reason = "please select one reason";
    }
     if (reasonToRemove?.reason === "Others") {
        if (!reasonToRemove.comment) {
          error.comment = "please provide reason to remove";
        }
        if (reasonToRemove.comment.length < 8) {
          error.comment = "please provide valid comment";
        }
     }

    // if (!reasonToRemove.comment) {
    //   error.comment = "please provide reason to remove";
    // }
    // if (reasonToRemove.comment.length < 8) {
    //   error.comment = "please provide valid comment";
    // }
    return error;
  }

  useEffect(() => {
    setReasonToRemoveError(validate());
  }, [reasonToRemove]);

  const fetchUserId = async () => {
    let data = localStorage.getItem("auth");
    let token = JSON.parse(data)?.accessToken;
    try {
      const query = `
    query {
      withAuth(token: "${token}"){
       userDetails{
        id,
        name {
          salutation
          first
          middle
          last
          full
        },
        emails {
          isPrimary
          isVerified
          address
        },
        phoneNumbers{
          number
        }
      }
      }
    }
      `;
      const response = await graphqlRequest(query);
      // console.log("175-->",response)
      return response;
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
    }
  };

  const trackCancOngLcbYes = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.CANCL_ONG_LJB_Y
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackCancOngLcbNo = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.CANCL_ONG_LJB_N
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackCancAccptedLcbYes = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);
      
      //set event data
      window.Moengage.track_event(
        eventHelpers.CANCL_ACCPT_LJB_Y
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackCancAccptedLcbNo = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.CANCL_ACCPT_LJB_N
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        p: 2
      }}
      onClick={() => handleJobPost()}
    >
      <Paper
        sx={{
          maxWidth: 600,
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          animation: "slideIn 0.3s ease-out"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            background: '#2D5FA1',
            // background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
            color: "white",
            position: "relative"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <WarningIcon sx={{ fontSize: 28 , color:'#ff6b6b'}} />
            <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>
              Cancel {title === "ongoing" ? "Ongoing" : title === "accepted" ? "Accepted" : ""} Job
            </Typography>
          </Box>
          <IconButton
            onClick={() => handleJobPost()}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "white",
              "&:hover": { background: "rgba(255, 255, 255, 0.1)" }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3 }}>
          {/* Alert Message */}
          <Alert 
            severity="warning" 
            sx={{ 
              mb: 3,
              "& .MuiAlert-message": { fontWeight: 500 }
            }}
          >
            Are you sure you want to cancel this {title} job? This action cannot be undone.
          </Alert>

          {/* Reason Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              Reason for cancellation *
            </Typography>
            <Reasonselect
              reasonToRemove={reasonToRemove}
              setReasonToRemove={setReasonToRemove}
              title="Select Reason"
            />
            {reasonToRemoveError.reason && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {reasonToRemoveError.reason}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Comments */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
              {reasonToRemove?.reason === "Others" ? (
                <>
                  Additional Comments <span style={{ color: "#ef4444" }}>*</span>
                </>
              ) : (
                "Additional Comments (Optional)"
              )}
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Please provide any additional details..."
              value={reasonToRemove.comment || ""}
              onChange={(e) =>
                setReasonToRemove({
                  ...reasonToRemove,
                  comment: e.target.value,
                })
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f9fafb"
                }
              }}
            />
            {reasonToRemoveError.comment && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <ErrorIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                <Typography variant="caption" color="error">
                  {reasonToRemoveError.comment}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              onClick={() => {
                pushEvent("Web_Job_Discard_No", {
                  page: title,
                  section: "Jobs",
                  applicationId: jobPostRemoveId?.allData?.id,
                  jobId: jobPostRemoveId?.allData?.job?.id,
                  jobCode: jobPostRemoveId?.allData?.job?.code,
                  jobSpecialization: jobPostRemoveId?.allData?.job?.specialization,
                  department: jobPostRemoveId?.allData?.job?.department,
                  hospitalName: jobPostRemoveId?.allData?.job?.hospitalName,
                  jobStart: jobPostRemoveId?.allData?.job?.start
                    ? new Date(Number(jobPostRemoveId?.allData?.job?.start)).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                  jobEnd: jobPostRemoveId?.allData?.job?.end
                    ? new Date(Number(jobPostRemoveId.allData.job.end)).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                  userId: jobPostRemoveId?.allData?.professional?.id,
                  name: jobPostRemoveId?.allData?.professional?.name?.full,
                  email: jobPostRemoveId?.allData?.professional?.emails?.find(e => e.isPrimary)?.address,
                  phone: jobPostRemoveId?.allData?.professional?.phoneNumbers?.find(p => p.isPrimary)?.number,
                  userSpecialization: jobPostRemoveId?.allData?.professional?.specialization?.name,
                  experience: jobPostRemoveId?.allData?.professional?.numExperience?.name,
                  city: jobPostRemoveId?.allData?.professional?.workCity?.name,
                  displayDate: jobPostRemoveId?.date,
                  displayEndDate: jobPostRemoveId?.endDate,
                });
                if (title === "ongoing") {
                  trackCancOngLcbNo();
                } else if (title === "accepted") {
                  trackCancAccptedLcbNo();
                }
                handleJobPost();
              }}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                borderColor: "#e5e7eb",
                color: "#6b7280",
                "&:hover": {
                  borderColor: "#d1d5db",
                  backgroundColor: "#f9fafb"
                }
              }}
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                pushEvent("Web_Job_Discard_Yes", {
                  page: title,
                  section: "Jobs",
                  applicationId: jobPostRemoveId?.allData?.id,
                  jobId: jobPostRemoveId?.allData?.job?.id,
                  jobCode: jobPostRemoveId?.allData?.job?.code,
                  jobSpecialization: jobPostRemoveId?.allData?.job?.specialization,
                  department: jobPostRemoveId?.allData?.job?.department,
                  hospitalName: jobPostRemoveId?.allData?.job?.hospitalName,
                  jobStart: jobPostRemoveId?.allData?.job?.start
                    ? new Date(Number(jobPostRemoveId?.allData?.job?.start)).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                  jobEnd: jobPostRemoveId?.allData?.job?.end
                    ? new Date(Number(jobPostRemoveId.allData.job.end)).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                  userId: jobPostRemoveId?.allData?.professional?.id,
                  name: jobPostRemoveId?.allData?.professional?.name?.full,
                  email: jobPostRemoveId?.allData?.professional?.emails?.find(e => e.isPrimary)?.address,
                  phone: jobPostRemoveId?.allData?.professional?.phoneNumbers?.find(p => p.isPrimary)?.number,
                  userSpecialization: jobPostRemoveId?.allData?.professional?.specialization?.name,
                  experience: jobPostRemoveId?.allData?.professional?.numExperience?.name,
                  city: jobPostRemoveId?.allData?.professional?.workCity?.name,
                  displayDate: jobPostRemoveId?.date,
                  displayEndDate: jobPostRemoveId?.endDate,
                });
                if (title === "ongoing") {
                  trackCancOngLcbYes();
                } else if (title === "accepted") {
                  trackCancAccptedLcbYes();
                }
                handleRemove();
              }}
              disabled={Object.keys(reasonToRemoveError).length !== 0}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#ef4444",
                "&:hover": {
                  backgroundColor: "#dc2626"
                },
                "&:disabled": {
                  backgroundColor: "#fca5a5",
                  color: "#ffffff"
                }
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default JobOptionModel;
